export default function () {
  // this.getCovenants()
  this.getAllCovenants()
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/resources/mounted.js